import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import DialogTitle from '@mui/material/DialogTitle';

const useStyles = makeStyles({
  container: {
    maxWidth: '75%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  label: {
    paddingBottom: 0,
    '& .MuiTypography-root': {
      fontWeight: 500,
    },
  },
  subLabel: {
    paddingTop: 0,
  },
});

const QuestionnaireStepHeader = ({ label, subLabel }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <DialogTitle classes={{ root: classes.label }}>{label}</DialogTitle>
      {subLabel && (
        <DialogTitle classes={{ root: classes.subLabel }}>
          {subLabel}
        </DialogTitle>
      )}
    </div>
  );
};

QuestionnaireStepHeader.defaultProps = {
  subLabel: undefined,
};

QuestionnaireStepHeader.propTypes = {
  label: PropTypes.string.isRequired,
  subLabel: PropTypes.string,
};

export default QuestionnaireStepHeader;
